<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Login to Continue</h2>
			</div>
		</div>

		<div class="main-section mgt-40">
			<div class="container">
                    <div class="main-card">
                            <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

                <div class="phrase-content">
					<div class="content-inner">
                            
                            <div class="confirmation sp">
                                    <strong> Security Phrase </strong>
                                  <p> Is your Security Phrase ? </p>
                                  <h2 class="text-uppercase"> {{vModel.passphrase}} </h2>
                            </div>



						<div class="button-wrap mar-t150">
							<button class="btn btn-not-me" type="button" @click="$parent.onPassPhraseCancel">Not Me</button>
							<button class="btn btn-yes" @click="$parent.onPassPhraseConfirm" type="button">Yes</button>
						</div>
					</div>
					<!--end Content inner-->
				</div>
                <!--end content-->
                </div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "loginpassphrase",
		props: ["vModel"],
	}
</script>
